/**
 * Created by hernanherreros on 2019-05-06
 */


import { colchagua2020FormRouterConfig, colchagua2020Steps } from './veterinario-colchagua-2020/config/router.config'
import { cartagena2020FormRouterConfig, cartagena2020Steps } from './veterinario-cartagena-2020/config/router.config'
import { vina2024FormRouterConfig, vina2024Steps } from './veterinario-vinadelmar-2024/config/router.config'
import { puyehue2024FormRouterConfig, puyehue2024Steps } from './veterinario-puyehue-2024/config/router.config'
import { chile2024FormRouterConfig, chile2024Steps } from './veterinario-chile-2024/config/router.config'
import { expoDemoFormRouterConfig, expoDemoSteps } from './expo-demo/config/router.config'
import * as React from 'react'

export const customRoutes: any = {
  'veterinario-colchagua-2020': colchagua2020FormRouterConfig,
  'veterinario-cartagena-2020': cartagena2020FormRouterConfig,
  'veterinario-vinadelmar-2024': vina2024FormRouterConfig,
  'veterinario-puyehue-2024': puyehue2024FormRouterConfig,
  'veterinario-chile-2024': chile2024FormRouterConfig,
  // 'veterinario-virtual-2021': virtual2021FormRouterConfig,
  // 'expo-demo': expoDemoFormRouterConfig,
}

export const customSteps: any = {
  'veterinario-puyehue-2023': ['information', 'success'],
  'veterinario-panama-2023': ['information', 'success'],
  'veterinario-chile-2023': ['information', 'success'],
  'veterinario-puntacana-2023': ['information', 'success'],
  'veterinario-colchagua-2023': ['information', 'success'],
  'veterinario-cartagena-2023': ['information', 'success'],
  'veterinario-panama-2024': ['information', 'success'],
  'veterinario-vinadelmar-2024': vina2024Steps,
  'veterinario-puyehue-2024': puyehue2024Steps,
  'veterinario-chile-2024': chile2024Steps,
  'expo-demo': ['information', 'success'],
}
